// extracted by mini-css-extract-plugin
export var center = "_1d-2";
export var clickableRow = "_1d-5";
export var expandedRow = "_1d-7";
export var hoverable = "_1d-4";
export var left = "_1d-1";
export var right = "_1d-3";
export var row = "_1d-0";
export var selectedRow = "_1d-6";
export var summaryRow = "_1d-8";